import { f7 } from 'framework7-react';
import { useState } from 'react';
import { buildRegisterCustomerParams } from './registerUserParams';
import { postRegisterCustomer } from '@/api/registerQRApi';
import { RegisterUserDataType } from '@/config/initialState';
import { useMobileAuth } from '@/hooks/api/auth/useMobileAuth';

type Data = {
  m_customer_id: number;
  unique_code: string;
};

export const useRegisterUser = () => {
  const [error, setError] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<Data>();
  const { authenticateMobile } = useMobileAuth();

  const registerCustomer = async (formData: RegisterUserDataType) => {
    setError(undefined);
    let response: Data | undefined = undefined;
    try {
      f7.preloader.show();
      setIsLoading(true);

      const params = buildRegisterCustomerParams(formData);
      const { affiliate_id } = formData;

      const res = await postRegisterCustomer(params);

      if (res?.data?.success) {
        response = {
          m_customer_id: res.data.m_customer_id,
          unique_code: res.data.unique_code,
        };
        setData({
          ...response,
        });

        // 会員登録成功後、SMS認証コードを送信
        // SMS認証コード送信はStep4（車検証登録）の「スキップ」または車検証登録完了後に行うように変更
        /*
        const mobileAuthParams: MobileAuthApiParams = {
          phone_no: params.phone_no1,
          selected_process: mobileAuthSelectedProcess.register,
          m_customer_id: res.data.m_customer_id,
          m_affiliate_id: affiliate_id ? String(affiliate_id) : undefined,
        };
        const authRes = await authenticateMobile(mobileAuthParams);
        if (!authRes?.success) {
          setError('会員登録は完了しましたが、SMSの送信に失敗しました');
        }
        */
      } else {
        setError(res?.data?.error?.message || '会員登録に失敗しました');
      }
    } catch (err: any) {
      setError(err?.message || '会員登録に失敗しました');
    } finally {
      setIsLoading(false);

      f7.preloader.hide();
    }
    return response;
  };
  return {
    data,
    error,
    isLoading,
    registerCustomer,
    setError,
  };
};
